<div class="{{ type.name }}" [class.enable-click]="!!enableClick">
    <div class="row {{ inactiveClass }}">
        <div class="col-xs-3 col-sm-2" *ngIf="!isGift">
            <div class="rat-3-4">
                <div class="rat-content">
                    <img class="img-responsive" [src]="(itemImagesUrl$ | async)?.main" (click)="actionItem()" alt="" />
                </div>
            </div>
        </div>
        <div class="col-xs-3 col-sm-2" *ngIf="isGift">
            <div class="rat-3-4">
                <div class="rat-content">
                    @if (enableClick) {
                        <img class="img-responsive" [src]="giftImage" (click)="actionItem()" alt="" />
                    } @else {
                        <img class="img-responsive" [src]="giftImage" alt="" />
                    }
                </div>
            </div>
        </div>
        <div class="col-xs-9 col-sm-10 is-flex content-sp-between flex-column">
            <div class="title-s ttu mb-8" *ngIf="isLastUnits$ | async">
                {{ 'dev.product.item.cart.lastUnits' | translate }}
            </div>
            <div class="is-flex content-sp-between">
                <div>
                    <div (click)="openModals()" *ngIf="showMessageStock">
                        <span class="text-m tag-warning mb-8" *ngIf="!hasStock">{{ item.stockItemKey | translate }}</span>
                    </div>
                    @if (enableClick) {
                        <div class="text-m ttu item-name" (click)="actionItem()" *ngIf="!isGift">{{ item.name }}</div>
                    } @else {
                        <div class="text-m ttu item-name" *ngIf="!isGift">{{ item.name }}</div>
                    }
                    <div class="text-m ttu item-name" *ngIf="isGift">{{ 'dev.cart.giftBox' | translate }}</div>
                    <div *ngIf="showDate" class="text-m">
                        {{ 'dev.myAccount.returns.date' | translate }}
                        <span>{{ date }}</span>
                    </div>
                    <div *ngIf="showDisplayReference || showReference" class="text-m c-dark-grey">
                        {{ 'dev.shopCart.item.ref' | translate }}
                        <ng-container *ngIf="showDisplayReference && item.displayReference && item.colorId">
                            <span>{{ item.displayReference }}/{{ item.colorId }}</span>
                        </ng-container>
                        <ng-container *ngIf="showReference && item.reference">
                            <span>{{ item.reference }}</span>
                        </ng-container>
                    </div>
                    <p class="title-m ttu text-info" *ngIf="showPreSaleKey">
                        {{ item.preSaleTypeKey | translate }}
                    </p>
                    <div class="row" *ngIf="item.isAutoAdd">
                        <div class="col-xs-12">
                            <div class="free-product text-l">{{ 'dev.shopCart.item.gift' | translate }}</div>
                        </div>
                    </div>
                    <div class="is-flex flex-row">
                        <ng-container *ngIf="showColor">
                            <div *ngIf="(itemImagesUrl$ | async)?.color" class="color-wrap">
                                <div class="flex-vcenter">
                                    <div class="product-color-selector pr-8">
                                        <button>
                                            <div class="color-selector">
                                                <img [src]="(itemImagesUrl$ | async)?.color" alt="" />
                                            </div>
                                        </button>
                                    </div>
                                    <div class="text-m mt-2">{{ colorName }}</div>
                                </div>
                            </div>
                        </ng-container>
                        <div *ngIf="showColorName" class="color-wrap">
                            <div class="flex-vcenter">
                                <div class="text-m mt-2">{{ colorName }}</div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="enableComposition && !isCard">
                        <span
                            class="c-dark-grey text-l text-underline has-ellipsis d-inline-block link-composition"
                            (click)="openCompositionModal()"
                            >{{ 'dev.cart.item.composition' | translate }}</span
                        >
                    </div>
                </div>
                <div *ngIf="!item?.isAutoAdd; else itemFree">
                    <ng-container *ngIf="itemPrices$ | async as price">
                        <formatted-price
                            [price]="price.price"
                            [secondaryPrice]="price.oldPrice"
                            [terciaryPrice]="price.originalPrice"
                            [options]="{ showAlternateCurrencies: true, noBreakPrice: true }"
                            [pricesClasses]="{
                                container: 'text-right text-nowrap text-m',
                                primaryPrice: price.primaryClass,
                                secondaryPrice: price.secondaryClass,
                                terciaryPrice: price.terciaryClass,
                                alternativeCurrencies: 'title-m ttu'
                            }"
                            [pricesStyles]="{
                                cmsStyles: { backgroundColor: price.backgroundColor, textColor: price.textColor }
                            }"
                        >
                            <span primaryText>{{ price.secondaryText | translate }}</span>
                        </formatted-price>
                    </ng-container>
                </div>
                <ng-template #itemFree>
                    <div class="col-xs-3 text-right">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="text-l free-product">
                                    {{ 'dev.general.noCost' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="row">
                <div class="col-xs-9 flex-vcenter">
                    <div class="row pr-16">
                        <div class="col-xs-12 item-product-cart-selector flex-wrap">
                            <div *ngIf="showQuantity" class="mr-16 flex-vcenter mb-8">
                                <div class="text-m mr-8">{{ 'dev.shopCart.item.quantity' | translate }}</div>
                                <ng-container *ngIf="showQuantityEdit; else quantity">
                                    <quantity-size-selector
                                        [keySelected]="quantitySelected"
                                        [options]="quantityOptions"
                                        (selectOption)="onSelectQuantity($event)"
                                    >
                                    </quantity-size-selector>
                                </ng-container>
                                <ng-template #quantity>
                                    <div class="text-m">{{ item.quantity }}</div>
                                </ng-template>
                            </div>
                            <div class="flex-vcenter mb-8" *ngIf="showSize">
                                <ng-container *ngIf="showSizeEdit; else size">
                                    <div class="text-m mr-8">{{ 'dev.shopCart.item.size' | translate }}</div>

                                    <quantity-size-selector
                                        [keySelected]="selectedSize"
                                        [options]="optionsSizes$ | async"
                                        (selectOption)="onSelectSize($event)"
                                    >
                                    </quantity-size-selector>
                                </ng-container>
                                <ng-template #size>
                                    <div class="product-size text-m">
                                        <span *ngIf="!oneSize"> {{ 'dev.shopCart.item.size' | translate }} </span>
                                        {{ sizeName }}
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-3 item-product-icons flex-vcenter content-end mb-8">
                    <div *ngIf="showActions" class="is-flex">
                        <ng-container *ngIf="actions$ | async as actions">
                            <button
                                *ngFor="let action of actions; index as i; trackBy: trackByAction"
                                class="{{ i === actions.length - 1 ? '' : '' }} btn btn-clear {{ action.changeWithStock ? 'state-changing' : '' }} {{
                                    action.image ? action.image : ''
                                }}"
                                (click)="launchEvent(action, item)"
                                [title]="action.title | translate"
                                [id]="action.event"
                            >
                                <svg-icon2 *ngIf="action.image" [category]="action.category" [src]="action.image"></svg-icon2>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Personalizaciones -->
            <ng-container *ngIf="isCustomization">
                <div class="row" *ngFor="let customization of item.customization">
                    <div class="col-xs-12">
                        <div class="mt-24 text-l">
                            <div class="text-l">{{ 'dev.shopCart.item.customized' | translate }}</div>
                            <div *ngIf="customization.text">{{ 'dev.general.initials' | translate }}: {{ customization.text }}</div>
                            <div *ngIf="customization.area?.name">
                                {{ 'dev.general.position' | translate }}: {{ customization.area.name | translate }}
                            </div>
                            <div *ngIf="customization.typography?.font" class="font-custom-{{ customization.typography?.name }}">
                                {{ 'dev.general.font' | translate }}: {{ customization.typography?.font }}
                            </div>
                            <div class="color-wrap" *ngIf="customization.color?.name">
                                <div class="name">{{ 'dev.general.color' | translate }}</div>

                                <button>
                                    <div class="color-selector">
                                        <span [ngStyle]="{ background: customization.color.hex }"></span>
                                    </div>
                                </button>
                                <!-- eslint-disable-next-line @angular-eslint/template/no-call-expression -->
                                <span class="color-name name">{{ customization.color?.name.replace(' ', '_') | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container></ng-container>
        </div>
    </div>
    <div class="row" *ngIf="showStockOrigin$ | async">
        <div class="col-xs-12 mt-8">
            <span class="text-l">{{ 'dev.shopCart.item.stockFromShop' | translate }}</span>
        </div>
    </div>
    <ng-content select="[selectContentBottom]"></ng-content>
</div>
